module.exports = __webpack_public_path__ + "img/game_main_pc_24_off.95c46372.png";